import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  TextField,
  SelectInput,
  Filter,
  ReferenceInput,
  required,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import { getTranslationByLocale } from '../utils/TranslationUtils';

const Title = t(({ record, locale }) => getTranslationByLocale(record.title, locale));

const AccountsFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Market" source="market" reference="markets" allowEmpty alwaysOn>
      <SelectInput optionText={<Title {...props} />} />
    </ReferenceInput>
  </Filter>
);

export const AccountsList = (props) => (
  <List {...props} filters={<AccountsFilter />}>
    <Datagrid>
      <TextField source="name" />
      <TextField source="type" />
      <EditButton {...props} basePath="/accounts" />
      <DeleteButton {...props} basePath="/accounts" />
    </Datagrid>
  </List>
);

const AccountsTitle = ({ record }) => <span>{record ? record.name : ''}</span>;

export const AccountsEdit = t((props) => (
  <Edit title={<AccountsTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" validate={[required]} />
      <ReferenceInput source="market" reference="markets" allowEmpty validate={[required]}>
        <SelectInput
          optionText="countryCode"
          optionValue="id"
          validate={[required]}
        />
      </ReferenceInput>
      <TextInput source="defaultId" />
      <SelectInput
        validate={[required]}
        source="type"
        choices={[
          { id: 'incoming', name: 'Incoming' },
          { id: 'outgoing', name: 'Outgoing' },
        ]}
      />
      <TextInput source="text" />
    </SimpleForm>
  </Edit>
));

export const AccountsCreate = t((props) => (
  <Create {...props}>
    <SimpleForm redirect="edit">
      <TextInput source="name" validate={[required]} />
      <TextInput source="defaultId" />
      <SelectInput
        validate={[required]}
        source="type"
        choices={[
          { id: 'incoming', name: 'Incoming' },
          { id: 'outgoing', name: 'Outgoing' },
        ]}
      />
      <TextInput source="text" />
    </SimpleForm>
  </Create>
));
